/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkItem } from '../models/work-item';
import { WorkProjectRoofTypesEnum } from '../models/work-project-roof-types-enum';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceItemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceItemsV2ControllerGetAllItems()` */
  static readonly SelfserviceItemsV2ControllerGetAllItemsPath = '/v2/selfservice/items';

  /**
   * Get all items.
   *
   * Returns all items
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceItemsV2ControllerGetAllItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceItemsV2ControllerGetAllItems$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkItem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceItemsService.SelfserviceItemsV2ControllerGetAllItemsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkItem>>;
      })
    );
  }

  /**
   * Get all items.
   *
   * Returns all items
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceItemsV2ControllerGetAllItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceItemsV2ControllerGetAllItems(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkItem>> {
    return this.selfserviceItemsV2ControllerGetAllItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkItem>>): Array<WorkItem> => r.body)
    );
  }

  /** Path part for operation `selfserviceItemsV2ControllerGetItemsByProductgroupId()` */
  static readonly SelfserviceItemsV2ControllerGetItemsByProductgroupIdPath = '/v2/selfservice/items/byProductgroupId/{productgroupId}/{roofType}';

  /**
   * Get items by product group ID.
   *
   * Returns all items with the specified product group ID that are visible for calculator, with optional roof type filtering
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceItemsV2ControllerGetItemsByProductgroupId()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceItemsV2ControllerGetItemsByProductgroupId$Response(
    params: {

    /**
     * ID of the product group
     */
      productgroupId: number;

    /**
     * Optional roof type filter
     */
      roofType: WorkProjectRoofTypesEnum;

    /**
     * return prices with item
     */
      withPrices?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkItem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceItemsService.SelfserviceItemsV2ControllerGetItemsByProductgroupIdPath, 'get');
    if (params) {
      rb.path('productgroupId', params.productgroupId, {});
      rb.path('roofType', params.roofType, {});
      rb.query('withPrices', params.withPrices, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkItem>>;
      })
    );
  }

  /**
   * Get items by product group ID.
   *
   * Returns all items with the specified product group ID that are visible for calculator, with optional roof type filtering
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceItemsV2ControllerGetItemsByProductgroupId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceItemsV2ControllerGetItemsByProductgroupId(
    params: {

    /**
     * ID of the product group
     */
      productgroupId: number;

    /**
     * Optional roof type filter
     */
      roofType: WorkProjectRoofTypesEnum;

    /**
     * return prices with item
     */
      withPrices?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkItem>> {
    return this.selfserviceItemsV2ControllerGetItemsByProductgroupId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkItem>>): Array<WorkItem> => r.body)
    );
  }

}
